<template>
  <div class="cart-summary2">
    <ModalConfirmMessages ref="modalConfirmMessages" v-if="confirmMessages.length > 0" @ok="emitPayClicked"/>
    <div class="cart-summary__wrap">
      <header class="checkout-section__header">
        <h2 class="checkout-section__header__title">{{ $t('pages.checkout.summary_section_title') }}</h2>
      </header>
      <div class="cart-summary__item">
        <div class="cart-summary__row" v-if="cartDigitalItems && cartDigitalItems.length > 0">
          <div class="text-nowrap">{{ $t('pages.checkout.summary_digital_items_total') }}
            <Icon name="infoCircle" width="18" class="cursor-pointer" vertical-align="top" v-b-tooltip.hover
                  :title="$t('pages.checkins_detail.price_list_desc1')"/>
          </div>
          <div>{{ totalCartItems.digital_items_total_original|formatCurrency(totalCartItems.currency) }}</div>
        </div>
      </div>
      <div class="cart-summary__fee-disc">
        <div class="cart-summary__subitem" v-if="totalCartItems.discount_total">
          <!-- DISCOUNT -->
          <div class="cart-summary__row">
            <div>{{ $t('pages.checkout.summary_discount_total') }}</div>
            <div>{{ totalCartItems.discount_total|formatCurrency(totalCartItems.currency) }}</div>
          </div>
        </div>

        <div class="cart-summary__subitem" v-if="totalCartItems.handling_fee">
          <!-- FEE -->
          <div class="cart-summary__row cart-summary__row--light cart-summary__row--expanded-header">
            <div>{{ $t('pages.checkout.summary_handling_fee') }}</div>
            <div class="text-nowrap">{{ totalCartItems.handling_fee|formatCurrency(totalCartItems.currency) }}</div>
          </div>
        </div>
      </div>
      <div class="cart-summary__total">
        <!-- TOTAL -->
        <div class="cart-summary__row">
          <div>{{ $t('pages.checkout.summary_grand_total') }}</div>
          <div class="value">{{ totalCartItems.grand_total|formatCurrency(totalCartItems.currency)  }}</div>
        </div>
      </div>

      <!--      <div class="mt-4 mb-3">
              <div class="d-flex align-items-center justify-content-between invoice-section">
                <span class="invoice-section__title">{{ $t('pages.checkout.need_invoice') }}</span>
                <b-form-checkbox switch size="lg" v-model="needInvoice"/>
              </div>
            </div>-->

      <header class="checkout-section__header" style="margin-top: 46px" v-if="!isZeroAmountOrder">
        <h2 class="checkout-section__header__title">{{ $t('pages.checkout.summary_payment_method') }}</h2>
      </header>


      <b-form-group class="m-0" v-if="!isZeroAmountOrder">
        <div class="cart-summary__body" v-if="showMercadoPagoGroupLabels">
          <div class="cart-summary__row  d-block d-inline-lg-block">
            <label class="grouper-mp-argentina"
                   v-if="showMercadoPagoGroupLabels">{{ $t('pages.checkout.payment_method_argentina') }}</label>
            <b-form-radio v-model="paymentMethodSelected" name="payment-method"
                          :value="PAYMENT_METHOD_MERCADO_PAGO"
                          class="payment-method-option payment-method-option--mercado-pago"
                          v-if="allowMercadoPagoPayment">
              {{ $t('pages.checkout.payment_method_mercado_pago') }}
            </b-form-radio>
            <InvoiceForm ref="invoiceForm" @validation="onValidation"
                         v-if="needInvoice && paymentMethodSelected === PAYMENT_METHOD_MERCADO_PAGO"/>
          </div>
        </div>
        <div class="cart-summary__body">
          <div class="cart-summary__row d-block d-inline-lg-block">
            <label class="grouper-mp-argentina"
                   v-if="showMercadoPagoGroupLabels">{{ $t('pages.checkout.payment_method_other_countries') }}</label>
            <b-form-radio v-model="paymentMethodSelected" name="payment-method" :value="PAYMENT_METHOD_CARD"
                          class="payment-method-option payment-method-option--cc"
                          v-if="allowCreditCardPayment">
              <div class="d-flex align-items-center justify-content-between w-100">
                <div>
                  {{ $t('pages.checkout.payment_method_card') }}
                  <div class="payment-method-subtitle">
                    {{ $t('pages.checkout.payment_methods_title') }}
                  </div>
                </div>
                <div>
                  <Icon name="creditCards" width="117"/>
                </div>
              </div>
            </b-form-radio>
            <InvoiceForm ref="invoiceForm" @validation="onValidation"
                         v-if="needInvoice && paymentMethodSelected === PAYMENT_METHOD_CARD"/>
          </div>

          <div class="cart-summary__row  d-block d-inline-lg-block" v-if="allowIdealPayment">
            <b-form-radio v-model="paymentMethodSelected" name="payment-method"
                          :value="PAYMENT_METHOD_IDEAL"
                          class="payment-method-option payment-method-option--ideal"
                          v-if="allowIdealPayment">
              {{ $t('pages.checkout.payment_method_ideal') }}
            </b-form-radio>
            <InvoiceForm ref="invoiceForm" @validation="onValidation"
                         v-if="needInvoice && paymentMethodSelected === PAYMENT_METHOD_IDEAL"/>
          </div>

          <div class="cart-summary__row d-block d-inline-lg-block" v-if="allowP24Payment">
            <b-form-radio v-model="paymentMethodSelected" name="payment-method"
                          :value="PAYMENT_METHOD_P24"
                          class="payment-method-option payment-method-option--p24"
                          v-if="allowP24Payment">
              {{ $t('pages.checkout.payment_method_p24') }}
            </b-form-radio>
            <InvoiceForm ref="invoiceForm" v-if="needInvoice && paymentMethodSelected === PAYMENT_METHOD_P24"/>
          </div>

          <div class="cart-summary__row  d-block d-inline-lg-block" v-if="allowBankTransferPayment">
            <b-form-radio v-model="paymentMethodSelected" name="payment-method"
                          :value="PAYMENT_METHOD_BANK_TRANSFER"
                          class="payment-method-option payment-method-option--bank"
                          v-if="allowBankTransferPayment">
              {{ $t('pages.checkout.payment_method_bank_transfer') }}
            </b-form-radio>
            <InvoiceForm ref="invoiceForm" @validation="onValidation"
                         v-if="needInvoice && paymentMethodSelected === PAYMENT_METHOD_BANK_TRANSFER"/>
          </div>
        </div>
      </b-form-group>
    </div>

    <div class="cart-summary__console" ref="cart-console">
      <b-button block variant="primary" @click="payClicked()" class="btn-pay" :disabled="!paymentEnabled">
        <template v-if="isZeroAmountOrder">
          {{ $t('pages.checkout.summary_action_get_for_free') }}
        </template>
        <template v-else>
          {{ $t('pages.checkout.summary_action_buy_mobile') }} - {{totalCartItems.grand_total|formatCurrency(totalCartItems.currency)}}
        </template>
      </b-button>
    </div>
  </div>

</template>


<script>
import {mapGetters, mapMutations} from 'vuex'
import {
  PAYMENT_METHOD_CARD,
  PAYMENT_METHOD_IDEAL,
  PAYMENT_METHOD_BANK_TRANSFER,
  PAYMENT_METHOD_MERCADO_PAGO, PAYMENT_METHOD_P24
} from "@/consts.js"
import InvoiceForm from "@/domain/checkout/InvoiceForm.vue";
import ModalConfirmMessages from "@/domain/checkout/modals/ModalConfirmMessages.vue";


export default {
  components: {
    ModalConfirmMessages,
    InvoiceForm
  },

  data() {
    return {
      paymentMethodSelected: null,
      needInvoice: false,
      invoiceFormIsValid: false
    }
  },

  created() {
    this.PAYMENT_METHOD_CARD = PAYMENT_METHOD_CARD
    this.PAYMENT_METHOD_BANK_TRANSFER = PAYMENT_METHOD_BANK_TRANSFER
    this.PAYMENT_METHOD_IDEAL = PAYMENT_METHOD_IDEAL
    this.PAYMENT_METHOD_MERCADO_PAGO = PAYMENT_METHOD_MERCADO_PAGO
    this.PAYMENT_METHOD_P24 = PAYMENT_METHOD_P24

    this.setDefaultPaymentMethod()

    if (this.allowMercadoPagoPayment) {
      this.loadMercadoPagoSdk()
    }
  },

  computed: {
    ...mapGetters('cartDigitalItems', [
      'paymentMethods',
      'totalCartItems',
      'cartDigitalItems',
      'confirmMessages'
    ]),

    isZeroAmountOrder() {
      return this.totalCartItems.grand_total === 0 && this.cartDigitalItems.length > 0
    },
    allowCreditCardPayment() {
      return this.paymentMethods.includes('card')
    },

    allowIdealPayment() {
      return this.paymentMethods.includes('ideal')
    },
    allowP24Payment() {
      return this.paymentMethods.includes('p24')
    },
    allowMercadoPagoPayment() {
      return this.paymentMethods.includes('mercado-pago')
    },
    allowBankTransferPayment() {
      return this.paymentMethods.includes('bank_transfer')
    },
    showMercadoPagoGroupLabels() {
      return this.allowMercadoPagoPayment && this.paymentMethods.length > 1
    },
    paymentEnabled() {
      if (this.needInvoice) return this.invoiceFormIsValid
      return true
    }
  },

  methods: {
    ...mapMutations('cart', ['SET_INVOICE']),
    // this method is necessary to preselect the default payment method
    // the default method is got from available payment methods form apis and re-mapped to local consts of vue
    // ideally the values from apis should match local constants...
    setDefaultPaymentMethod() {
      let firstMethodPayment
      let paymentMethod
      if (this.paymentMethods.length > 0) {
        firstMethodPayment = this.paymentMethods[0]
        if (firstMethodPayment === 'card') paymentMethod = PAYMENT_METHOD_CARD
        if (firstMethodPayment === 'ideal') paymentMethod = PAYMENT_METHOD_IDEAL
        if (firstMethodPayment === 'mercado-pago') paymentMethod = PAYMENT_METHOD_MERCADO_PAGO
        if (firstMethodPayment === 'p24') paymentMethod = PAYMENT_METHOD_P24
        if (firstMethodPayment === 'bank_transfer') paymentMethod = PAYMENT_METHOD_BANK_TRANSFER
      }
      return this.$set(this, 'paymentMethodSelected', paymentMethod)
    },
    async payClicked() {
      if (this.needInvoice) {
        let invoiceForm = await this.$refs.invoiceForm.validate()
        if (!invoiceForm) return false
        this.SET_INVOICE(invoiceForm)
      }

      if(this.confirmMessages.length > 0) {
        this.$refs.modalConfirmMessages.open()
        return
      }

     this.$emit('pay-clicked', this.isZeroAmountOrder ? null : this.paymentMethodSelected)
    },
    emitPayClicked() {
      this.$emit('pay-clicked', this.isZeroAmountOrder ? null : this.paymentMethodSelected)
    },
    loadMercadoPagoSdk() {
      const script = document.createElement("script");
      script.src = "https://sdk.mercadopago.com/js/v2"
      script.async = false
      script.defer = false
      document.body.appendChild(script)
    },
    onValidation(value) {
      this.invoiceFormIsValid = value
    }
  }
}
</script>
